import { useQuery } from "@tanstack/react-query";
import { Navigate, useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { ROUTES } from "@/app/router";
import { formQueriesStore } from "@/features/forms/api";
import { DynamicForm } from "@/features/forms/components";
import { useSubmitDietitianForm } from "@/features/forms/hooks";
import type { Answers } from "@/features/forms/models";
import { LogoLoader } from "@/shared/components";

export const DietitianScreen = () => {
  const navigate = useNavigate();
  const {
    data: dietitianForm,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(formQueriesStore.dietitian);

  const submitMutation = useSubmitDietitianForm();

  const handleSubmit = (answers: Answers) => {
    if (dietitianForm) {
      submitMutation.mutate(
        { formId: dietitianForm.formId, answers },
        { onSuccess: () => navigate(ROUTES.COACHING.DIETITIAN_SCHEDULE) },
      );
    }
  };

  if (isError) {
    return <Navigate to={ROUTES.COACHING.OVERVIEW} />;
  }

  return (
    <ScreenLayout
      hasCardHeader={false}
      title={t`Dietitian form questions`}
      description={t`(*) Mandatory field`}
    >
      {isSuccess && (
        <DynamicForm
          form={dietitianForm}
          onSubmit={handleSubmit}
          submitLabel={t`Schedule`}
        />
      )}

      <LogoLoader
        show={isLoading || submitMutation.isPending}
        fullscreen={submitMutation.isPending}
      />
    </ScreenLayout>
  );
};
